import { render } from "./ModalEditRRIM.vue?vue&type=template&id=b99e3d12&scoped=true"
import script from "./ModalEditRRIM.vue?vue&type=script&lang=js"
export * from "./ModalEditRRIM.vue?vue&type=script&lang=js"

import "./ModalEditRRIM.vue?vue&type=style&index=0&id=b99e3d12&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99e3d12"]])

export default __exports__